import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CharityRowData } from '../components/charity-row/charity-row.component';

/**
 * Mock service for charity data
 * Provides sample charity data for development and testing
 */
@Injectable({
  providedIn: 'root'
})
export class CharityMockService {
  private mockCharities: CharityRowData[] = [
    {
      organisationUuid: '4a6f496e-638e-4886-846d-d3631d3bed6d',
      creationDate: 1638305976683,
      rank: 100,
      organisationLogoUrl: 'https://s3.us-east-1.amazonaws.com/tgf-gs-files/4a6f496e-638e-4886-846d-d3631d3bed6d/organisationImage/lsp.jpg',
      organizationVideoUrl: null,
      organisationName: 'RESURRECTION CHURCH BEIRUT',
      executiveSummary: 'At RCB, we exist to make disciples for Jesus Christ. We are a Bible-based and Spirit-led Church that loves God and people.',
      organisationLeader: null,
      causeName: 'Promotion of Christian Faith',
      donorNumber: null,
      projects: [
        {
          uuid: 'e00e8bcb-d543-402d-bdee-2f7efd06cf38',
          name: 'HOPE AND A FUTURE'
        }
      ],
      organisationCountriesNames: ['Lebanon'],
      organisationCategoriesNames: ['Faith: Supporting Church Associations'],
      languageCode: 'eng',
      badges: [
        {
          uuid: 'ecd738ba-6167-4cc8-87e0-dc3207f111e0',
          name: 'THE MACLELLAN FOUNDATION',
          rank: 1,
          image: {
            uuid: '52d1e8fe-ed5f-4933-a967-58ccd86fc578',
            url: 'https://s3.us-east-1.amazonaws.com/tgf-gs-files//badgeImage/Maclellan_Signature_Navy_Medium1024px.png',
            filename: '/badgeImage/Maclellan_Signature_Navy_Medium1024px.png',
            type: 'image/png'
          }
        }
      ]
    },
    {
      organisationUuid: '7b8c123e-456f-789a-bcde-f0123456789a',
      creationDate: 1640000000000,
      rank: 95,
      organisationLogoUrl: 'https://s3.us-east-1.amazonaws.com/tgf-gs-files/placeholder-charity-2.jpg',
      organizationVideoUrl: null,
      organisationName: 'GLOBAL EDUCATION INITIATIVE',
      executiveSummary: 'Empowering communities through quality education and literacy programs. We believe every child deserves access to learning opportunities.',
      organisationLeader: null,
      causeName: 'Education and Literacy',
      donorNumber: null,
      projects: [
        {
          uuid: 'a1b2c3d4-e5f6-7890-1234-567890abcdef',
          name: 'Schools for All'
        }
      ],
      organisationCountriesNames: ['Kenya', 'Uganda', 'Tanzania'],
      organisationCategoriesNames: ['Education: Primary Schools', 'Community Development'],
      languageCode: 'eng',
      badges: []
    },
    {
      organisationUuid: '9c8d234f-567g-890b-cdef-g1234567890b',
      creationDate: 1645000000000,
      rank: 90,
      organisationLogoUrl: 'https://s3.us-east-1.amazonaws.com/tgf-gs-files/placeholder-charity-3.jpg',
      organizationVideoUrl: null,
      organisationName: 'CLEAN WATER PROJECT',
      executiveSummary: 'Providing access to clean, safe drinking water in underserved communities. Building wells and water systems that transform lives.',
      organisationLeader: null,
      causeName: 'Water and Sanitation',
      donorNumber: null,
      projects: [
        {
          uuid: 'b2c3d4e5-f6g7-8901-2345-67890bcdefab',
          name: 'Wells of Life'
        }
      ],
      organisationCountriesNames: ['India', 'Bangladesh'],
      organisationCategoriesNames: ['Infrastructure: Water Systems', 'Health: Preventive Care'],
      languageCode: 'eng',
      badges: []
    },
    {
      organisationUuid: 'd9e8345g-678h-901c-defg-h2345678901c',
      creationDate: 1650000000000,
      rank: 85,
      organisationLogoUrl: 'https://s3.us-east-1.amazonaws.com/tgf-gs-files/placeholder-charity-4.jpg',
      organizationVideoUrl: null,
      organisationName: 'MEDICAL CARE FOUNDATION',
      executiveSummary: 'Delivering essential healthcare services to rural and remote areas. Our mobile clinics bring medical care to those who need it most.',
      organisationLeader: null,
      causeName: 'Healthcare Access',
      donorNumber: null,
      projects: [
        {
          uuid: 'c3d4e5f6-g7h8-9012-3456-7890cdefabcd',
          name: 'Mobile Health Clinics'
        }
      ],
      organisationCountriesNames: ['Philippines', 'Indonesia'],
      organisationCategoriesNames: ['Health: Primary Care', 'Medical Services'],
      languageCode: 'eng',
      badges: []
    },
    {
      organisationUuid: 'e0f9456h-789i-012d-efgh-i3456789012d',
      creationDate: 1655000000000,
      rank: 80,
      organisationLogoUrl: 'https://s3.us-east-1.amazonaws.com/tgf-gs-files/placeholder-charity-5.jpg',
      organizationVideoUrl: null,
      organisationName: 'YOUTH EMPOWERMENT CENTER',
      executiveSummary: 'Equipping young people with skills, mentorship, and opportunities for success. Building the next generation of leaders.',
      organisationLeader: null,
      causeName: 'Youth Development',
      donorNumber: null,
      projects: [
        {
          uuid: 'd4e5f6g7-h8i9-0123-4567-890defabcdef',
          name: 'Leadership Training'
        }
      ],
      organisationCountriesNames: ['South Africa', 'Zimbabwe'],
      organisationCategoriesNames: ['Youth Programs', 'Vocational Training'],
      languageCode: 'eng',
      badges: []
    },
    {
      organisationUuid: 'f1g0567i-890j-123e-fghi-j4567890123e',
      creationDate: 1660000000000,
      rank: 75,
      organisationLogoUrl: 'https://s3.us-east-1.amazonaws.com/tgf-gs-files/placeholder-charity-6.jpg',
      organizationVideoUrl: null,
      organisationName: 'HUNGER RELIEF NETWORK',
      executiveSummary: 'Fighting hunger and malnutrition through food distribution and agricultural training. No one should go to bed hungry.',
      organisationLeader: null,
      causeName: 'Food Security',
      donorNumber: null,
      projects: [
        {
          uuid: 'e5f6g7h8-i9j0-1234-5678-90efabcdefgh',
          name: 'Nutrition Programs'
        }
      ],
      organisationCountriesNames: ['Haiti', 'Guatemala'],
      organisationCategoriesNames: ['Food Distribution', 'Agriculture Support'],
      languageCode: 'eng',
      badges: []
    }
  ];

  /**
   * Gets featured charities (first 5)
   */
  getFeaturedCharities(): Observable<CharityRowData[]> {
    return of(this.mockCharities.slice(0, 5));
  }

  /**
   * Gets all available charities
   */
  getAllCharities(): Observable<CharityRowData[]> {
    return of(this.mockCharities);
  }

  /**
   * Gets a charity by UUID
   */
  getCharityByUuid(uuid: string): Observable<CharityRowData | undefined> {
    const charity = this.mockCharities.find(c => c.organisationUuid === uuid);
    return of(charity);
  }
}
